"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.catalogReducers = void 0;
var setCatalogItems = function (state, action) {
    var _a = action.payload, attributes = _a.attributes, measures = _a.measures, dateDatasets = _a.dateDatasets, facts = _a.facts;
    state.attributes = attributes;
    state.measures = measures;
    state.facts = facts;
    state.dateDatasets = dateDatasets;
};
exports.catalogReducers = {
    setCatalogItems: setCatalogItems,
};
//# sourceMappingURL=catalogReducers.js.map